export default __webpack_public_path__ + "static/media/jumbo_two.3e7c648d.png";